import "./content.scss";

const PrivacyPolicyContent = ({ data }) => {
  const { pageSectionId, title, description } = data || {};

  return (
    <div id={pageSectionId} className="items_content">
      <div className="item" key={title}>
        <h2 className="title">{title}</h2>
        <div
          className="text text-regular"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
    </div>
  );
};
export default PrivacyPolicyContent;
